import { db } from "../Config";

export const fetchTratamientosLab = async () => {
  let tratamientos = [];
  await db
    .collection("tratamientos")
    .orderBy("tratamiento")
    .where("envLab", "==", true)
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        tratamientos.push({
          id: doc.id,
          tipo: doc.data().tipo,
          tratamiento: doc.data().tratamiento,
          preciosLabs: doc.data().preciosLabs,
          estado: doc.data().estado,
        });
      });
    })
    .catch((err) => {
      throw new Error(err);
    });
  return tratamientos;
};

export const fetchTratamientosCompletos = async (empresaId) => {
  try {
    const baseSnapshot = await db.collection("tratamientos_base").get();
    const personalizadosSnapshot = await db
      .collection(`empresas/${empresaId}/tratamientos`)
      .get();

    // Mapear tratamientos base con origen "base"
    const base = baseSnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
      origen: "base",
      empresaId: empresaId // Asegurar que tenga empresaId
    }));

    // Mapear tratamientos personalizados con origen "personalizado"
    const personalizados = personalizadosSnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
      origen: "personalizado",
      empresaId: empresaId // Asegurar que tenga empresaId
    }));

    // Crear un mapa de tratamientos personalizados por ID para búsqueda rápida
    const personalizadosMap = new Map();
    personalizados.forEach(p => {
      const key = p.codTra || p.codtra;
      if (key) personalizadosMap.set(key, p);
    });

    // Combinar manteniendo los personalizados y añadiendo los base que no estén personalizados
    const combinados = base.map(b => {
      const key = b.codTra || b.codtra;
      // Si existe un personalizado para este tratamiento base, usarlo heredando campos base si faltan en el personalizado
      if (key && personalizadosMap.has(key)) {
        const p = personalizadosMap.get(key);
        return {
          ...b,
          ...p,
          tiempo: (p.tiempo !== undefined && p.tiempo !== null && p.tiempo !== "") ? p.tiempo : b.tiempo,
          costo: (p.costo !== undefined && p.costo !== null && p.costo !== "") ? p.costo : b.costo,
          precio: (p.precio !== undefined && p.precio !== null && p.precio !== "") ? p.precio : b.precio,
        };
      }
      return b;
    });

    //Añadir cualquier tratamiento personalizado que no tenga equivalente en base
    const personalizadosSinBase = personalizados.filter(p => {
      const pKey = p.codTra || p.codtra;
      return !base.some(b => (b.codTra || b.codtra) === pKey);
    });
    combinados.push(...personalizadosSinBase);

    console.log("Tratamientos combinados:", combinados);
    return combinados;
  } catch (error) {
    console.error("Error al cargar tratamientos:", error);
    throw error;
  }
};



export const fetchTratamientos = (empresaId) => {
  return new Promise((resolve, reject) => {
    let tratamientos = [];
    db.collection("tratamientos")
      .where("empresaId", "==", empresaId)
      .onSnapshot((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          tratamientos.push(doc.data());
        });
        resolve(tratamientos);
      },(error) => {
        reject(error)
        // Handle errors
      });
      
  });
};


export const getTratamientoById = (tratamientoId) => {
  return new Promise((resolve, reject) => {
    db.collection("tratamientos")
      .doc(tratamientoId)
      .get()
      .then((doc) => {
        resolve(doc.data());
      }).catch((err)=>
      reject(err)
      );
      
  });
};

